import React, { useState } from "react";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";

const OpenAIPage = () => {
    const jobDescription = sessionStorage.getItem("jobDescription");
    const resume = sessionStorage.getItem("resume");

    const [input, setInput] = useState("Hello I am the candidate lets proceed with the interview" || ""); // User input
    const [response, setResponse] = useState(""); // GPT response
    const [conversation, setConversation] = useState([
        {
            role: "system",
            content: `You are a friendly interviewer that is interviewing a candidate. 
            Here is the job description (${jobDescription}), and here is the candidate's resume (${resume}).
            Please begin the interview process.`,
        },
    ]); // Keeps track of the conversation history

    const azureSpeechKey = "3MdbFNhgCv4RWgKWaRISEFtib8HxNVA6ivMyUla4RGlQQGJkgMEaJQQJ99AKACYeBjFXJ3w3AAAYACOGbwyg";
    const azureSpeechRegion = "eastus";

    const speechConfig = sdk.SpeechConfig.fromSubscription(azureSpeechKey, azureSpeechRegion);
    const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
    const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);

    const handleSend = async (newPrompt) => {
        const apiKey = "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"; // Replace with your OpenAI API key
        const url = "https://api.openai.com/v1/chat/completions";

        if (!newPrompt.trim()) {
            alert("Please enter a message before sending.");
            return;
        }

        // Append the user newPrompt to the conversation history
        const updatedConversation = [
            ...conversation,
            { role: "user", content: newPrompt.trim() },
        ];

        try {
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiKey}`,
                },
                body: JSON.stringify({
                    model: "gpt-3.5-turbo", // or "gpt-4"
                    messages: updatedConversation, // Include conversation history
                    max_tokens: 100,
                }),
            });

            const data = await res.json();

            if (data.choices && data.choices.length > 0) {
                const aiResponse = data.choices[0].message.content;

                // Append AI response to the conversation history
                setConversation((prev) => [
                    ...prev,
                    { role: "user", content: newPrompt.trim() },
                    { role: "assistant", content: aiResponse },
                ]);

                setResponse(aiResponse); // Display the latest AI response

                // Convert AI response to speech
                await textToSpeech(aiResponse, listenForSpeech);
            } else {
                setResponse("No response from GPT.");
            }
        } catch (error) {
            console.error("Error communicating with OpenAI:", error);
            setResponse("An error occurred.");
        }

        setInput(""); // Clear the input box
    };

    const textToSpeech = async (text, onComplete) => {
        recognizer.stopContinuousRecognitionAsync();//Stops listening for voice input.

        const speechConfig = sdk.SpeechConfig.fromSubscription(azureSpeechKey, azureSpeechRegion);
        speechConfig.speechSynthesisVoiceName = "en-US-CoraMultilingualNeural"; // Change voice as needed
    
        const player = new sdk.SpeakerAudioDestination(); // Use speaker output with event handling
        const audioConfig = sdk.AudioConfig.fromSpeakerOutput(player);
        const synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);
    
        // Attach an event listener for when the audio playback ends
        player.onAudioEnd = () => {
            console.log("Audio playback finished.");
    
            // Call the onComplete callback if provided
            if (onComplete && typeof onComplete === "function") {
                onComplete();
            }
        };
    
        synthesizer.speakTextAsync(
            text,
            (result) => {
                if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
                    console.log("Speech synthesized for text:", text);
                } else {
                    console.error("Speech synthesis canceled:", result.errorDetails);
                }
                synthesizer.close();
            },
            (error) => {
                console.error("Error during speech synthesis:", error);
                synthesizer.close();
            }
        );
    };

    // Starts listening
    const listenForSpeech = async () => {
        //const speechConfig = sdk.SpeechConfig.fromSubscription(azureSpeechKey, azureSpeechRegion);
        //const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
        //const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
    
        recognizer.recognizing = (sender, event) => {
            console.log(`Intermediate result: ${event.result.text}`);
        };
    
        recognizer.recognized = (sender, event) => {
            if (event.result.reason === sdk.ResultReason.RecognizedSpeech) {
                console.log("Recognized Speech:", event.result.text);
                recognizer.stopContinuousRecognitionAsync();
                handleSend(event.result.text); // Send recognized text to your handler
            } else {
                console.error("Speech recognition failed:", event.result.errorDetails);
            }
        };
    
        recognizer.canceled = (sender, event) => {
            console.error(`Recognition canceled: ${event.reason}`);
            recognizer.stopContinuousRecognitionAsync();
        };
    
        recognizer.sessionStopped = (sender, event) => {
            console.log("Session stopped. Stopping recognition.");
            recognizer.stopContinuousRecognitionAsync();
        };
    
        recognizer.startContinuousRecognitionAsync(
            () => {
                console.log("Continuous recognition started.");
            },
            (err) => {
                console.error("Error starting continuous recognition:", err);
                recognizer.close();
            }
        );
    };

    const handleInitiate = async () => {
        //setInput("Begin Conversation");
        await handleSend(input);
    }

    //const handleSpeachToText = async () => {
    //    await speechToText();
    //    handleSend();
    //}

    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor: "#f9f9f9" }}>
            <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                <h1 style={{ fontSize: "24px", color: "#333", textAlign: "center", marginBottom: "20px" }}>
                    Ready... Set...
                </h1>
                <button
                    onClick={handleInitiate}
                    style={{
                        display: "block",
                        width: "100%",
                        padding: "10px",
                        marginBottom: "10px",
                        fontSize: "16px",
                        backgroundColor: "#007BFF",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Begin Interview
                </button>
                {/* <button
                    onClick={speechToText}
                    style={{
                        display: "block",
                        width: "100%",
                        padding: "10px",
                        marginBottom: "10px",
                        fontSize: "16px",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Start Listening
                </button> */}
                {/*<textarea
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Type your message here"
                    rows={5}
                    style={{
                        width: "100%",
                        padding: "10px",
                        marginBottom: "10px",
                        fontSize: "16px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        boxSizing: "border-box",
                    }}
                />*/}
                {/*<button
                    onClick={() => handleSend(input)}
                    style={{
                        display: "block",
                        width: "100%",
                        padding: "10px",
                        marginBottom: "10px",
                        fontSize: "16px",
                        backgroundColor: "#007BFF",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Send
                </button>*/}
                <div style={{ marginTop: "20px" }}>
                    <h2 style={{ fontSize: "20px", color: "#333", borderBottom: "2px solid #007BFF", paddingBottom: "5px" }}>
                        Response:
                    </h2>
                    <p style={{ fontSize: "16px", color: "#555", padding: "10px", backgroundColor: "#f7f7f7", borderRadius: "5px" }}>
                        {response}
                    </p>
                </div>
                {<div style={{ marginTop: "20px" }}>
                    <h2 style={{ fontSize: "20px", color: "#333", borderBottom: "2px solid #007BFF", paddingBottom: "5px" }}>
                        Conversation History:
                    </h2>
                    <ul
                        style={{
                            listStyle: "none",
                            paddingLeft: "10px",
                            display: "flex",
                            flexDirection: "column-reverse", // Ensures the list is reversed
                            maxHeight: "300px", // Set a max height for scrolling
                            overflowY: "auto", // Enable scrolling
                        }}
                    >
                        {conversation.map((msg, index) => (
                            <li
                                key={index}
                                style={{
                                    marginBottom: "10px",
                                    padding: "10px",
                                    backgroundColor: msg.role === "user" ? "#e9f5ff" : "#f7f7f7",
                                    borderRadius: "5px",
                                }}
                            >
                                <strong style={{ color: "#007BFF" }}>
                                    {msg.role === "user" ? "You:" : msg.role === "assistant" ? "GPT:" : "System:"}
                                </strong>{" "}
                                <span style={{ fontSize: "16px", color: "#333" }}>{msg.content}</span>
                            </li>
                        ))}
                    </ul>
                </div>}
            </div>
        </div>
    );
};

export default OpenAIPage;
